import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { usePackState } from '../../../data/pack-store';
import { openDetailWithUrl } from '../../../app/url-sync';
import { StatusIcon } from '../../icons/StatusIcon';
import { ViewTestsIcon } from './HeaderIcons';
import styles from './header.module.css';

/**
 * kaneai's "View tests" popover (TestRunSidebar inside LTAnchoredOverlay),
 * rebuilt lean over pack data: lists the run's instances; clicking one swaps
 * the open detail. Right-anchored card below the trigger button.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TestListPopover(_ref) {
  var currentId = _ref.currentId;
  var rowIds = usePackState(function (s) {
    return s.rowIds;
  });
  var rows = usePackState(function (s) {
    return s.rows;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var rootRef = useRef(null);
  useEffect(function () {
    if (!open) return undefined;
    var onDown = function onDown(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    var onKey = function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return function () {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.popoverRoot,
    ref: rootRef,
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      className: "".concat(styles.iconButton, " ").concat(styles.iconButtonDefault),
      "aria-label": "View tests",
      "aria-haspopup": "dialog",
      "aria-expanded": open,
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      children: /*#__PURE__*/_jsx(ViewTestsIcon, {})
    }), open && /*#__PURE__*/_jsx("div", {
      className: styles.popoverCard,
      role: "dialog",
      "aria-label": "Tests in this run",
      children: /*#__PURE__*/_jsx("ul", {
        className: styles.popoverList,
        children: rowIds.map(function (id) {
          var row = rows.get(id);
          if (!row || row.state !== 'loaded') return null;
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "".concat(styles.popoverItem, " ").concat(id === currentId ? styles.popoverItemCurrent : ''),
              "aria-current": id === currentId ? 'true' : undefined,
              onClick: function onClick() {
                setOpen(false);
                if (id !== currentId) openDetailWithUrl(id);
              },
              children: [/*#__PURE__*/_jsx(StatusIcon, {
                status: row.status,
                size: 16
              }), /*#__PURE__*/_jsx("span", {
                className: styles.popoverItemTitle,
                title: row.title,
                children: row.title
              })]
            })
          }, id);
        })
      })
    })]
  });
}